<div mat-dialog-content>
  <span class="snack">Dear Visitor,</span>
  <span class="snack"> We recommend you to check our Patient Apps page.</span>

  <div mat-dialog-actions>
    <button mat-button (click)="OkClick()" class="snackbtn">
      <span class="a404">Take me there</span>
    </button>
    <button mat-button (click)="NoClick()" class="snackbtn">
      <span class="a404">No, thanks</span>
    </button>
  </div>
</div>
